export enum PixelGroup {
  PreConsumptionEvents = 'preConsumptionEvents',
  SalesEvents = 'salesEvents'
}

export enum PixelPhase {
  ProductClick = 'product_click',
  ComboClickBuy = 'combo_click_buy',
  KeepWatchingClick = 'keep_watching_click',
  ProductPurchasedClick = 'product_purchased_click'
}
